import axios from 'axios'
import notification from 'helpers/notification'
import store from 'store/index'
import { authorization } from 'store/user'
class API {
	async baseAPI({
		auth = true,
		data,
		hasTransformResponse = true,
		headers = {},
		method = 'GET',
		params = {},
		url = '',
	}) {
		const token = localStorage.getItem('token') || ''
		const language = localStorage.getItem('i18nextLng') || ''
		const host = window.location.host
		// api hosts
		const apiMainHost = process.env.REACT_APP_API_MAIN_HOST
		const apiDemoHost = process.env.REACT_APP_API_DEMO_HOST
		const apiDevHost = process.env.REACT_APP_API_DEV_HOST
		// app hosts
		const appMainHost = process.env.REACT_APP_MAIN_HOST
		const appDemoHost = process.env.REACT_APP_DEMO_HOST
		const appDevHost = process.env.REACT_APP_DEV_HOST
		const appTestHost = process.env.REACT_APP_TEST_HOST
		const baseURL =
			appMainHost === host
				? apiMainHost
				: appDemoHost === host
				? apiDemoHost
				: [appDevHost, appTestHost].includes(host)
				? apiDevHost
				: apiDevHost
		const newHeaders = {
			'Accept-Language': language,
			...(auth ? { Authorization: `Bearer ${token}` } : {}),
			...headers,
		}
		const transformResponse = axios.defaults.transformResponse.concat(
			(data, _, status) => {
				const language = localStorage.getItem('i18nextLng') || 'uz'
				const serverErrorMessage =
					language === 'uz' ? 'Server xatoligi' : 'Ошибка на сервере'
				const message = status === 500 ? serverErrorMessage : ''
				if (message) {
					notification(message, { type: 'error' })
				}
				const isAuthorizationError = status === 401 && url !== '/users/profile'
				if (isAuthorizationError) {
					const authErrorMessage =
						language === 'uz'
							? 'Token muddati tugagan'
							: 'Срок действия токена истёк'
					notification(authErrorMessage, { type: 'error' })
					localStorage.clear()
					store.dispatch(authorization({ STATUS: 'ERROR', user: null }))
				}
				return data
			}
		)
		const transform = hasTransformResponse ? { transformResponse } : {}
		const options = {
			...transform,
			baseURL,
			data,
			headers: newHeaders,
			method,
			params,
			url,
		}
		const api = axios(options)
		return api
	}
}
const api = new API()
export const baseAPI = api.baseAPI
export default API
